<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isOpen() {
      return this.value >= 90;
    },
  },
});
</script>

<template>
  <div class="measure-name grow">
    <img src="@/assets/images/pool.svg" alt="pool" v-if="isOpen" />
    <img src="@/assets/images/pool-open.svg" alt="pool" v-else />
  </div>
  <div class="text-lg">
    {{ isOpen ? $t("PoolCovered") : $t("PoolUncovered") }}
  </div>
</template>
